import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'global';
export const actionTypes = {
  GLOBAL_RELOAD: `${FEATURE_NAME}/GLOBAL_RELOAD`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
